<template>
  <v-card class="mt-3 rounded-0 gray-on-visit ev-2" @click="openLoadDetail">
    <div
      class="pl-4 d-flex my-auto grey--text flex-row-reverse justify-space-between"
    >
      <span class="d-flex flex-row-reverse my-auto py-1">
        <span class="x-small pr-1">{{
          $utils.getTimeDiff(load.createdAt)
        }}</span>
        <v-icon class="grey--text mr-3" small>mdi-clock</v-icon>
      </span>
      <small
        v-if="loadStep.step !== 7"
        class="py-1 pr-3 pl-5"
        :class="loadStep.step === 0 ? 'digikala--text' : 'custom-badge'"
      >
        <v-icon
          small
          v-if="loadStep.step === 0"
          class="digikala--text force-color"
          >mdi-close</v-icon
        >
        {{ loadStep.name }}
      </small>
    </div>

    <v-divider></v-divider>

    <div class="py-2 pr-4">
      <!-- Loadings -->
      <svg-icon name="ring"></svg-icon>
      <span class="pr-3 high-emp subtitle2-medium"
        >{{ `${firstLoadingPlace.city} - ${firstLoadingPlace.ostan}` }}
        <v-avatar
          v-if="!!firstLoadingPlace.stop && firstLoadingPlace.stop > 1"
          size="20"
          class="ml-2 grey lighten-2 body2-regular"
          v-text="firstLoadingPlace.stop"
        ></v-avatar>
      </span>
      <div class="pr-2" style="height: 18px">
        <v-divider vertical class="custom-divider"></v-divider>
      </div>

      <!-- Destinations -->
      <v-icon x-small color="#08284D">mdi-square</v-icon>
      <span class="pr-3 high-emp subtitle2-medium"
        >{{ `${lastDestination.city} - ${lastDestination.ostan}` }}
        <v-avatar
          v-if="!!lastDestination.stop && lastDestination.stop > 1"
          size="20"
          class="ml-2 grey lighten-2 body2-regular"
          v-text="lastDestination.stop"
        ></v-avatar>
      </span>
    </div>

    <v-row justify="space-between" class="mx-4 mt-1 border-top">
      <div class="py-1 px-0 caption-regular high-emp my-auto">
        {{ `${load.vehicle} - ${load.barbar}` }}
      </div>
      <div class="my-1 pb-05 px-0 d-flex justify-end medium-emp">
        <!-- load.safi_type == 2 -->
        <span
          v-if="false"
          class="blue--text text--darken-3 caption-regular my-auto"
        >
          صافی به ازای هر تن
        </span>
        <span v-else class="caption-regular my-auto">جمع پرداختی</span>
        <span class="logistic--text mx-2 h6-medium my-auto">
          {{ $utils.formatNumber(total) }}
        </span>
        <svg-icon name="toman"></svg-icon>
      </div>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "LoadCard",
  props: {
    load: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      steps: [
        {
          name: "عدم همکاری راننده",
          status: "canceled",
          step: 0,
        },
        {
          name: "در انتظار تایید اطلاعات",
          status: "submitted",
          step: 1,
        },
        {
          name: "در انتظار تخصیص باربری",
          status: "validator_accepted",
          step: 2,
        },
        {
          name: "در انتظار تخصیص راننده",
          status: "driver_waiting",
          step: 3,
        },
        {
          name: "در انتظار صدور بارنامه",
          status: ["driver_was_found", "waybill_uploaded"],
          step: 4,
        },
        {
          name: "در انتظار بارگیری راننده",
          status: "waybill_accepted",
          step: 5,
        },
        {
          name: "در انتظار تخلیه بار",
          status: "loaded",
          step: 6,
        },
        {
          name: "تحویل شد",
          status: "delivered",
          step: 7,
        },
      ],
    };
  },
  computed: {
    isInLoadDetail() {
      return this.$route.name === "LoadDetail";
    },
    loadStep() {
      const status = this.load.status;
      const steps = this.steps;

      return steps.filter((step) => {
        return step.status.includes(status);
      })[0];
    },
    total() {
      return Number(this.load.price) / 10;
    },
    firstLoadingPlace() {
      // this condition will be useless on 1402
      if (!this.load.sendersAndRecievers.length) {
        return {
          city: this.load.loading_city,
          ostan: this.load.loading_ostan,
        };
      }

      // const sr = this.load.sendersAndRecievers[0];
      const sr = this.load.sendersAndRecievers.filter(
        (sr) => sr.is_sender === true
      );
      const sr_first = sr[0];

      let result = {
        city: sr_first.city,
        ostan: sr_first.ostan,
        stop: sr.length,
      };
      return result;
    },
    lastDestination() {
      // this condition will be useless on 1402
      if (!this.load.sendersAndRecievers.length) {
        return {
          city: this.load.destination_city,
          ostan: this.load.destination_ostan,
        };
      }

      const sr = this.load.sendersAndRecievers.filter(
        (sr) => sr.is_sender === false
      );
      const sr_last = sr.slice(-1)[0];

      let result = {
        city: sr_last.city,
        ostan: sr_last.ostan,
        stop: sr.length,
      };
      return result;
    },
  },
  methods: {
    openLoadDetail() {
      if (!this.isInLoadDetail) {
        this.$router.push({
          name: "LoadDetail",
          params: {
            loadId: this.load.objectId,
          },
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.x-small {
  font-size: 10px;
}
.border-top {
  border-top: 1px solid rgba(224, 224, 224, 0.4);
}
.custom-divider {
  height: 18px;
  border-color: rgba(8, 40, 77, 0.25);
  transform: scaleY(1.5);
  top: -8px;
  right: -1px;
  position: relative;
}
.gray-on-visit:visited {
  background-color: #f5f5f5;
}
.v-card::before {
  background-color: transparent;
}
.custom-badge {
  clip-path: polygon(0 100%, 11% 0, 100% 0, 100% 100%);
  background-color: var(--logistic);
  color: white;
}
</style>
